import React, { Component } from 'react';

import "./Calendar-Headeritem.scss"

class HeaderItem extends Component {
    constructor() {
        super();
        this.state = {
        }
    }
    render() {
        return (
            <li>
                <div className="box">
                    <div className="padding">
                        {this.props.item.name}
                    </div>
                </div>
            </li>
        )
    }
}

export default HeaderItem;



// WEBPACK FOOTER //
// ./src/components/Calendar/components/Calendar-Headeritem/Calendar-Headeritem.js